import i18n from 'i18n';
import * as Yup from 'yup';

export default () => {
  return Yup.object().shape({
    replace_instances: Yup.object().shape({
      instance_block_user_message: Yup.string().when('notify_users', {
        is: true,
        then: Yup.string()
          .required(i18n.t('REQUIRED_FIELD_KEY'))
          .nullable(true),
        otherwise: Yup.string().nullable(true),
      }),
    }),
  });
};
